import React, { useState } from 'react';
import { Formik } from 'formik';
import FormInput from '../../../general/form-input/form-input.component';
import Button from '../../../general/button/button.component';
import './formPlaced.styles.scss';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Padding from '../../../general/padding/Padding';
import db from '../../../../firebase.config';
import { doc, setDoc, getDoc, collection, getDocs } from "firebase/firestore"; 
import { useNavigate } from 'react-router-dom';
let xlsx = require('json-as-xlsx');

let hasChecked = false;
let formPlacedRef, studentDataRef;
let formPlacedRefSnapshot, studentDataRefSnapshot;
let listOfCompanies = [];
let finalList = [];


const PersonalDetails = () => {

  const navigate = useNavigate();

  const countUpdater = async () => {

    const formPlacedCountRef = doc(db, 'counterList', 'facultyDataPlaced');
    const formPlacedCountSnapshot = await getDoc(formPlacedCountRef);
    const count = formPlacedCountSnapshot.data().count + 1;
    setDoc(formPlacedCountRef, { count : count } , { merge: true });
    //maintaining seperate counter collection for counters, updating counter when data is pushed

  }
  
  const handleChecker = async (USN) => {

        formPlacedRef = doc(db, 'facultyDataPlaced', USN);
        formPlacedRefSnapshot = await getDoc(formPlacedRef);
        //get document pertaining to USN in facultyDataPlaced

        studentDataRef = doc(db, 'studentData', USN);
        studentDataRefSnapshot = await getDoc(studentDataRef);
        //get document pertaining to USN in studentData
        //wait for data fetch to complete

        if(studentDataRefSnapshot.exists())
        {
          listOfCompanies = studentDataRefSnapshot.data().companies;
          //get the list of companies student is placed in
          if(listOfCompanies.length === 2)
            {
              alert('Student has already been placed in 2 companies');
            }
          else
            {
              alert('Type in the rest of the details to add to database');
              hasChecked = true;
            }
            // listOfCompanies.push({company : data.company, typeofjob : data.typeofjob, salary: data.salary });
            // //prepare the companies object for push to db
            // //if student document exists, then check if student has under 3 offers
        }
        else
        {
          alert('Student has not signed up in the portal!')
        }
    }

    const dataRetriever = async () => {

      const allPlacedStudentsRef = collection(db, "facultyDataPlaced");
      const docsSnapshot = await getDocs(allPlacedStudentsRef);
      console.log(docsSnapshot);
      docsSnapshot.forEach((doc) => {
        finalList.push(doc.data());
      });
      return finalList;

    };

    const handleDownload = () => {

      const time = new Date();
      let settings = {
        fileName: `PlacedStudents_${time}`, // Name of the resulting spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
      }
      //settings
      
      const xlsxContent = []; //to generate xlsx content array

      dataRetriever().then(finalList => {

        finalList.forEach((item) => {
          const secondCompany = item.companies[1]?true:false;
          xlsxContent.push(
          {
          USN : item.USN,
          company1 : item.companies[0].company,
          ctc1 : item.companies[0].salary,
          fi1 : item.companies[0].typeofjob,
          company2 : secondCompany?item.companies[1].company:null,
          ctc2 : secondCompany?item.companies[1].salary:null,
          fi2 : secondCompany?item.companies[1].typeofjob:null
          }
          )
        });
      //prepare data object
        let data = [
          {
            sheet: 'Eligible Candidates',
            columns: [
              { label: 'USN', value: 'USN' }, 
              { label: 'Company - 1', value: 'company1' },
              { label: 'CTC - 1', value: 'ctc1' },
              { label: 'Type Of Job - 1', value: 'fi1' }, 
              { label: 'Company - 2', value: 'company2' }, 
              { label: 'CTC - 2', value: 'ctc2' }, 
              { label: 'Type Of Job - 2', value: 'fi2' }
            ],
            content: xlsxContent
          }
        ]
        //content
      
        xlsx(data, settings) 
        // Will download the excel file
      })

    }

  return (
  <div>
    <Formik
      initialValues={{ company: '', typeofjob: '', salary: '', USN: ''}}
      validate={values => {
        const errors = {};
        if (!values.USN) {
          errors.USN = 'Required';
        }
        if (!values.company || !hasChecked) {
          errors.company = 'Required';
        }
        if (!values.typeofjob || !hasChecked) {
          errors.typeofjob = 'Required';
        }
        if (!values.salary || !hasChecked) {
          errors.salary = 'Required';
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting, handleSubmit }) => {

  const data = JSON.parse(JSON.stringify(values, null, 2));
  console.log(values);
  listOfCompanies.push(data);
  const studentOtherData = studentDataRefSnapshot.data();
  //only if student has under 3 offers, add new companies to list-of-companies placed in and push to data
              setDoc(formPlacedRef , { companies : listOfCompanies ,  USN : data.USN } , { merge: true });
              setDoc(studentDataRef , { companies : listOfCompanies } , { merge: true });
              //after adding to db, update counter in the other counter db
  countUpdater().then((response)=>{console.log(response)})
  setSubmitting(false);
  setTimeout(() => {navigate(`../`);},3000)

}}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting
      }) => (
        
      <form onSubmit={handleSubmit}> 
        <span className="personal-details" >

        <Padding/>
        <Typography variant="h4" sx={{fontFamily:'Montserrat'}}>Details of placed student</Typography>
            <FormInput
              placeholder="USN"
              type="text"
              name="USN"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.USN}
            />
            <span style={{fontFamily : 'Montserrat'}}>{touched.USN && errors.USN}</span>
            <Button type="button" onClick={() => {handleChecker(values.USN)}}>
              Check
            </Button>
            <Divider sx={{mt : 2, mb: 2}}/>
            <Typography variant="h4" sx={{fontFamily:'Montserrat', mb : 2}}>Click below to get the list of all placed students</Typography>
            <Button type="button" onClick={() => {handleDownload()}}>
              Download
            </Button>
        </span>
          
        <span className="personal-details" style={{marginBottom:'1px'}}>
          <Padding/>
          <Padding/>
          <FormInput
            placeholder="Company Name"
            type="text"
            name="company"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.company}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.company && errors.company}</span>
          <FormInput
            placeholder="Internship/Full-time"
            type="text"
            name="typeofjob"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.typeofjob}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.typeofjob && errors.typeofjob}</span>
          <FormInput
            placeholder="CTC/Stipend"
            type="number"
            name="salary"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.salary}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.salary && errors.salary}</span>
          <Button type="submit" disabled={isSubmitting}>
            Next
          </Button>
        </span>
      </form>
      )}
    </Formik>
  </div>
  );
}

export default PersonalDetails;

